import React from "react";
import {
  Shirt,
  Briefcase,
  ShoppingBag,
  Package,
  Globe,
  Wallet,
  CreditCard,
  Sparkles,
  Droplet,
  Flame,
  LayoutGrid
} from "lucide-react";

// Custom inline SVG icon for Pants/Trousers since it is not in the main lucide-react package
export const Pants = ({ size = 24, strokeWidth = 2, className = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    <path d="M6 3h12l1 18h-4L12 11l-3 10H5Z" />
  </svg>
);

export const iconMap = {
  Shirt,
  Pants,
  Briefcase,
  ShoppingBag,
  Package,
  Globe,
  Wallet,
  CreditCard,
  Sparkles,
  Droplet,
  Flame,
  LayoutGrid
};

/**
 * Get the icon component by its exact name string
 * @param {string} iconName 
 * @returns {React.Component}
 */
export const getIconComponent = (iconName) => {
  return iconMap[iconName] || Package;
};

/**
 * Dynamically map a category name to a visual representation icon
 * @param {string} categoryName 
 * @returns {React.Component}
 */
export const getCategoryIcon = (categoryName) => {
  const name = (categoryName || '').toLowerCase().trim();
  if (name.includes('shirt')) return Shirt;
  if (name.includes('pant') || name.includes('jeans')) return Pants;
  if (name.includes('bag') || name.includes('backpack')) return ShoppingBag;
  if (name.includes('wallet')) return Wallet;
  if (name.includes('card') || name.includes('payment')) return CreditCard;
  if (name.includes('fragrance') || name.includes('perfume') || name.includes('deodorant') || name.includes('droplet')) return Droplet;
  if (name.includes('grooming') || name.includes('gel') || name.includes('shave')) return Flame;
  if (name.includes('belt') || name.includes('cap') || name.includes('accessory') || name.includes('accessories')) return Briefcase;
  return Package; // fallback
};
